import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
  })
  export class AppStateService {
      private blockNavigation: boolean = false;
      private supportPortalMode: boolean = false;
      private featureFlagsMode: boolean = false;
  
    constructor() { }

  getBlockNavigation(): boolean {
    return this.blockNavigation;
  }
  setBlockNavigation(flag: boolean) {
    console.log("blockNavigation was set to: ", flag);
    this.blockNavigation = flag;
  }
  
  getSupportPortalMode(){
    return this.supportPortalMode;
  }
  setSupportPortalMode(flag: boolean){
    console.log("supportPortalMode was set to: ", flag);
    this.supportPortalMode = flag;
  }

  getFeatureFlagsMode(){
    return this.featureFlagsMode;
  }

  setFeatureFlagsMode(flag: boolean){
    console.log("featureFlagsMode was set to: ", flag);
    this.featureFlagsMode = flag;
  }

  getEnvironmentClientId(){
    if (this.supportPortalMode) {
      return environment.supportPortalClientId;
    }
    else if (this.featureFlagsMode) {
      return environment.featureFlagsClientId;
    } else {
      return environment.clientId;
    }
  }

  isCloudDev(): Boolean {
    let cloud = environment.cloud? environment.cloud : '';
    if(cloud === 'dev'){
      return true;
    }
    else{
      return false; 
      /* 
       This branch may be hard to test unless we make an
       EnvironmentService to get the Environment Configuration.
      */
    }
  }

}
  